;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fingerprintjs = require('@fingerprintjs/fingerprintjs');

var _fingerprintjs2 = _interopRequireDefault(_fingerprintjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      deviceId: '',
      error: null,
      isLoading: false
    };
  },

  methods: {
    getDeviceIdentifier: async function getDeviceIdentifier() {
      this.isLoading = true;
      this.error = null;

      try {
        var fp = await _fingerprintjs2.default.load();
        var result = await fp.get();
        this.deviceId = result.visitorId;
        this.$emit('fingerprint', this.deviceId);
      } catch (err) {
        this.error = err.message;
        this.deviceId = this.basicFallback();
        this.$emit('fingerprint', this.deviceId);
      } finally {
        this.isLoading = false;
      }
    },
    basicFallback: function basicFallback() {
      var data = [navigator.userAgent, screen.width, screen.height, screen.colorDepth, new Date().getTimezoneOffset()].join('#');
      return this.hash(data);
    },
    hash: function hash(str) {
      var hashValue = 0;
      for (var i = 0; i < str.length; i++) {
        hashValue = (hashValue << 5) - hashValue + str.charCodeAt(i);
        hashValue |= 0;
      }
      return hashValue.toString();
    }
  },
  mounted: function mounted() {
    this.getDeviceIdentifier();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"device_id"},domProps:{"value":_vm.deviceId}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"device_error"},domProps:{"value":_vm.error}})])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35c8df31", __vue__options__)
  } else {
    hotAPI.reload("data-v-35c8df31", __vue__options__)
  }
})()}